import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { SUCCESS, TEXT_AUDIO } from 'constants/videoTranscript';

import {
  selectFillerWordRanges,
  selectFillerWordRemoval,
  selectNumFillerWordsInVideoVersion,
  selectTranscriptionStatus,
} from 'selectors/transcripts';

import FillerVolumeControl from '.';

const MuteFillerWord = ({ videoRef, inTrimMode }) => {
  const fillerRanges = useSelector(selectFillerWordRanges);
  const fillerWordRemoval = useSelector(selectFillerWordRemoval);
  const numFillerWordsInVideo = useSelector(selectNumFillerWordsInVideoVersion);
  const fillerWordsPresent = numFillerWordsInVideo > 0;
  const fillerVolumeControl = useRef(null);
  const transcriptStatus = useSelector(selectTranscriptionStatus);

  // initialization
  // does nothing if there are no filler words
  useEffect(() => {
    if (
      !videoRef ||
      fillerVolumeControl?.current ||
      !fillerWordsPresent ||
      inTrimMode
    ) {
      return;
    }

    fillerVolumeControl.current = new FillerVolumeControl({
      videoRef,
      fillerRanges,
    });
  }, [videoRef, fillerRanges, fillerWordsPresent, inTrimMode]);

  // behavior
  // if there's no fillerVolumeControl, it does nothing
  // the initialization step takes care of defining it
  useEffect(() => {
    if (!videoRef || !fillerVolumeControl?.current) {
      return;
    }

    // FillerVolumeControl needs an explicit call to enable to start doing things
    // disable should do an early return in case it has not been enabled
    if (fillerWordRemoval === TEXT_AUDIO && transcriptStatus === SUCCESS) {
      fillerVolumeControl.current.enable(fillerRanges);
    }

    if (fillerWordRemoval !== TEXT_AUDIO || transcriptStatus !== SUCCESS) {
      fillerVolumeControl.current.disable();
    }
  }, [
    fillerWordRemoval,
    fillerVolumeControl,
    videoRef,
    transcriptStatus,
    fillerRanges,
  ]);

  return null;
};

export default MuteFillerWord;
